import * as constants from './constants';
import * as apiHelper from '../../apiHelper';
const controller = "search";

export function populateResults(results) {
  return {
    type: constants.POPULATE_RESULTS,
    data: results
  }
}
export function resetFilters() {
  return {
    type: constants.RESET_FILTERS
  }
}

export function searchComplete() {
  return {
    type: constants.SEARCH_COMPLETE
  }
}

export function searchStarted() {
  return {
    type: constants.SEARCH_STARTED
  }
}

export function setHovered(id) {
  return {
    type: constants.HOVERED_LISTING,
    data: id
  }
}

export function toggleMobileView() {
  return {
    type: constants.SHOW_MAP
  }
}

export function updateFilters(filters) {
  return {
    type: constants.UPDATE_FILTERS,
    data: filters
  }
}

export function setSort(sort) {
  return {
    type: constants.SEARCH_SET_SORT,
    data: sort
  }
}

export function doSearch(values) {
  return (dispatch) => {
    dispatch(searchStarted());
    return apiHelper.apiPost(controller, { filters: values }, null)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      })
      .then(json => {
        dispatch(searchComplete());
        if (json && json.listings) {
          dispatch(populateResults(json));
        } else {
          dispatch(populateResults({
            listings: []
          }));
        }
      })
  }
}

export function doFeaturedDestinationMapSearch(values) {
  return (dispatch) => {
    return apiHelper.apiPost("near", { filters: values }, null)
      .then(response => response.json())
      .then(json => dispatch(populateResults(json)))
  }
}
